<template>
    <div>
        <CardBase>
            <div v-if="componentAtual !== 'vCreate'">
                <MacroSubHeader
                    title="Indicados"
                    icon="el-icon-star-off"
                >
                </MacroSubHeader>
    
                <el-tabs type="border-card" v-model="activeTabName" class="mt-3">
                    <el-tab-pane name="first" lazy>
                        <span slot="label">
                            <i class="el-icon-user"></i>
                            <span class="ml-1">Revendedoras</span>
                        </span>
    
                        <v-adm-revendedoras-indicadas></v-adm-revendedoras-indicadas>
                    </el-tab-pane>
            
                    <el-tab-pane v-if="!isDistributor" name="second" lazy>
                        <span slot="label">
                            <i class="el-icon-office-building"></i>
                            <span class="ml-1">Distribuidores</span>
                        </span>
            
                        <v-adm-distribuidores-indicados @importarDistribuidor="createProspecto"></v-adm-distribuidores-indicados>
                    </el-tab-pane>
                </el-tabs>
            </div>
    
            <component 
                :is="componentAtual" 
                @showProspecto="showProspecto" 
                :propProspectoId="currentProspecto"
                :acao="acao"
            >
            </component>
        </CardBase>
    </div>
</template>
<script>

    import {
        Card,
        Tabs, 
        TabPane, 

    } from 'element-ui'

    import CardBase from '@/components/_macro/CardBase.vue';
    import MacroSubHeader from '@/components/_macro/MacroSubHeader.vue';

    import Create from "../adm_prospecto/Create.vue";

    export default {
        data() {
            return {
                activeTabName: 'first',
                tabIndex: 0,
                componentAtual: '',
                currentProspecto: 0,
                acao: '',
            }
        },
        methods: {
            showProspecto(id, acao) {
                this.currentProspecto = id;
                this.acao = acao;
                this.componentAtual = 'vCreate';
            },
            createProspecto() {
                this.acao = 'import';
                this.currentProspecto = 0;
                this.componentAtual = 'vCreate';
            },
        },
        computed: {
            isDistributor() {
                return this.$store.getters['user/isDistributor']();
            }
        },
        components: {
            vCreate: Create,
            CardBase,
            MacroSubHeader,
            [Card.name]: Card,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane, 
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/indicados/Index.vue